
import {Component, Prop} from "vue-property-decorator";
import {
    HcPageModel,
} from "@dev/hc-components";
import TemplateOptions from "@/module/main/page/TemplateOptionsEnum";
import Culture from "@/module/main/page/CultureEnum";
import ICarLoan from "@/module/main/model/applicationForm/ICarLoan";

@Component
export default class CarLoan extends HcPageModel
{
    @Prop({type: Object}) public value!: ICarLoan;
    @Prop({type: String}) public culture!: Culture;
    @Prop({type: String}) public template!: TemplateOptions;

    protected pageName: string = "carLoan";
}
